import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "./tailwind/dialog";
import { Text } from "./tailwind/text";
import { Field, Label } from "./tailwind/fieldset";
import { Input } from "./tailwind/input";
import { Badge } from "./tailwind/badge";
import { Description } from "./tailwind/fieldset";
import { Button } from "./tailwind/button";
import { useState } from "react";
import { api } from "../api";
import posthog from "posthog-js";
import { useNavigate } from "react-router";

export function DialogLibraryFlow({
  active,
  toggleActive,
  selectedLibraryFlow,
  campaignName,
  handleNameChange,
  hasAutomations,
}) {
  const navigate = useNavigate();
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const handleCreateFlow = async () => {
    setIsCreateLoading(true);
    const newCampaign = await api.copyCampaignNodesAndEdges({
      oldCampaignId: selectedLibraryFlow?.originalScenario?.campaign?.id,
      oldScenarioId: selectedLibraryFlow?.originalScenario?.id,
      campaignName: campaignName,
      libraryFlowId: selectedLibraryFlow?.id,
    });
    posthog.capture("create_flow", {
      source: "library",
      type: hasAutomations ? "automation" : "campaign",
    });
    navigate(
      `/${hasAutomations ? "automations" : "campaigns"}/edit/${newCampaign.id}`,
    );
  };
  return (
    <Dialog
      open={active}
      className="h-[94vh] flex flex-col m-0"
      style={{ zIndex: "999999999" }}
      onClose={toggleActive}
      size="full"
    >
      <div className="flex">
        <DialogTitle close={true}>{selectedLibraryFlow.title}</DialogTitle>
      </div>
      <div className="flex h-full">
        <div className="w-[30%] border-r pr-4 h-full overflow-y-auto scroll-color my-2">
          <Text className="text-sm">Description</Text>
          <Text className="text-sm my-5 text-gray-600">
            {selectedLibraryFlow.fullDescription}
          </Text>

          <Field>
            <Label>Name</Label>
            <Input
              name="scenario_name"
              value={campaignName}
              onChange={handleNameChange}
              autoComplete="off"
              className="ml-1"
            ></Input>
          </Field>

          {selectedLibraryFlow.tags && selectedLibraryFlow.tags.length > 0 && (
            <>
              <Text className="text-sm mt-2">Tags</Text>
              <div className="flex">
                {selectedLibraryFlow.tags.map((tag, index) => {
                  return (
                    <div className="m-1" key={`tag-${index}`}>
                      <Badge color="zinc">{tag}</Badge>
                    </div>
                  );
                })}
              </div>
            </>
          )}
          {hasAutomations && (
            <>
              <Text className="text-sm mt-2">Trigger</Text>
              <Description className="text-sm">
                {selectedLibraryFlow.automationType}
              </Description>

              {selectedLibraryFlow.requirements &&
                selectedLibraryFlow.requirements.length > 0 && (
                  <>
                    <Text className="text-sm mt-2">Prerequisites</Text>
                    <div className="flex">
                      <ul>
                        {selectedLibraryFlow.requirements.map(
                          (requirement, index) => {
                            return (
                              <li className="m-1" key={`requirement-${index}`}>
                                {/* Add icon based on whether the customer meets the condition */}
                                {requirement}
                              </li>
                            );
                          },
                        )}
                      </ul>
                    </div>
                  </>
                )}
            </>
          )}
        </div>
        <div className="flex flex-col w-[70%]">
          <DialogBody className="flex-1 overflow-y-auto scrollbar h-full">
            <div>
              <img
                src={selectedLibraryFlow.flowImageUrl}
                alt=""
                className="w-full object-contain"
              />
            </div>
          </DialogBody>
          <DialogActions className="mx-auto">
            <Button color="secondaryButton" onClick={toggleActive}>
              Cancel
            </Button>
            <Button
              color="primaryButton"
              onClick={() => handleCreateFlow()}
              loading={isCreateLoading}
            >
              Create flow
            </Button>
          </DialogActions>
        </div>
      </div>
    </Dialog>
  );
}
